export const BOOKSTERA_READER_APP_URL =
  'https://play.google.com/store/apps/details?id=com.bookstera.app';
